<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div id="details" class="row">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityId)">
                                    <label>City</label>

                                    <select required name="cityId" class="form-control" :disabled="isCityDisable" v-model="transport.cityId">
                                        <option value="" disabled>Select City Name</option>
                                        <option v-for="cityId in citys" :value="cityId.id">{{ cityId.name }}
                                        </option>
                                    </select>
                                    <field-messages name="cityId" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.transportName)">
                                    <label>Transfer Point Name</label>
                                    <input maxlength="25" type="text" name="transportName" class="form-control" required v-model="transport.transportName" placeholder="Transfer Point Name" pattern="^[^0-9][a-zA-Z0-9 ]{0,25}$" />
                                    <field-messages name="transportName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Transfer Point Name is a required field
                                        </div>
                                        <div slot="pattern">
                                            Alphabets/Numbers are allowed.
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>

                        <!-- <vue-google-autocomplete
                                id="map"
                                classname="form-control"
                                placeholder="Start typing"
                                v-on:placechanged="getAddressData"
                            /> -->

                        <div class="col-sm-12">
                            <!-- <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.transportLocation)">
                                    <label>Transfer Point Location</label>
                                    <div class="inputwrapper">
                                    <input type="text" name="transportLocation" class="form-control" required v-model="transport.transportLocation" pattern="^(.{1,200})$" placeholder="Transport Location">
                                    <div class="maps" data-toggle="modal" data-target="#exampleModal"><i class="fa fa-map-marker" aria-hidden="true"></i></div>
                                    </div>
                                    <field-messages name="transportLocation" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">Transfer Point Location Name is a required field</div>
                                        <div slot="pattern">Transfer Point Location should be less than 200 characters</div>
                                    </field-messages>
                                </validate>
                            </div> -->
                            <div class="col-sm-6">
                                <div class="location_label">
                                    <location @change-event="setIsDisable" />
                                </div>
                            </div>
                        </div>
                    </vue-form>
                    <!-- v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]" -->
                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'transport' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createTransport" :disabled="!(formstate.$dirty && formstate.$valid && isDisable)" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>
                        <button class="btn gradientbt mr-5" type="submit" @click="updateTransport" :disabled="
                  !isDisable && !(formstate.$dirty && formstate.$valid)
                " v-if="$route.params && $route.params._id != '0'">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
</template>

<script>
import TransportLocation from "./transportLocation.vue";
import {
    formService,
    eventBus,
    transportService
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";
import {
    mapState
} from "vuex";

import VueGoogleAutocomplete from "vue-google-autocomplete";

import location from "../gmapLocation/location";

export default {
    name: "transportPointCreate",
    // components: {
    //     location
    //     },

    components: {
        location,
    },
    data() {
        return {
            markersss: {
                position: {
                    lat: 28,
                    lng: 70,
                },
            },
            markerrs: {
                position: {
                    lat: 28.0,
                    lng: 70.0
                },
            },
            center: {
                lat: 28,
                lng: 70,
            },
            mapOptions: {
                disableDefaultUI: true,
            },
            isCityDisable: false,
            isDisable: false,
            currentPlace: null,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            transport: {
                cityId: "",
            },
            oldTransport: {},
            transportId: [],
            googleLocation: {},
            coordinates: [],
            citys: {},
            // userId: this.$route.params._id,
        };
    },
    // mounted: function() {
    //     this.getRegionList()
    // },
    mounted() {
        this.getCityList();
    },

    methods: {
        fieldClassName: formService.fieldClassName,
        setIsDisable(value) {
            this.isDisable = value;
        },

        getCityList() {
            if (this.$store.state.auth.user.role.key === "cityAdmin") {
                const {
                    _id,
                    cityName
                } = this.$store.state.auth.user.cityId;
                this.citys = [{
                    id: _id,
                    name: cityName
                }];
                this.transport["cityId"] = _id;
                this.isCityDisable = true;
                return;
            }
            this.loading = true;
            const params = {};
            let cityList = [];
            // params.page = 1;
            // params.limit = 999;
            this.$cityRepository
                .collectionCitysList(params)
                .then((res) => {
                    this.loading = false;
                    res.data.response.forEach((element) => {
                        if (element.status === true) {
                            cityList.push({
                                name: element.cityName,
                                id: element._id,
                            });
                        }
                    });
                    cityList.sort((item1, item2) => {
                        return item1.name.toLowerCase() < item2.name.toLowerCase() ? -1 : 1;
                    });
                    this.citys = cityList;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error("citys.requestFunction-error:", error);
                    this.$snotify.error("Get citys list failed", "Error!");
                });
        },

        getTransport() {
            const params = {
                // $embed: ['user']
            };
            return this.$transportDataRepository
                .find(this.$route.params._id, params)
                .then((response) => {
                    this.transport = response.data;
                    this.oldTransport = _.cloneDeep(this.transport);
                    this.$store.dispatch(
                        "setBreadcrumbTitle",
                        this.transport.transportName
                    );
                    let location = {};
                    location["name"] = this.transport.transportLocation;
                    location["long"] = this.transport.geoloc[0];
                    location["lat"] = this.transport.geoloc[1];
                    eventBus.$emit("getgeoLocation", location);
                })
                .catch((error) => {
                    console.error("TransportDetails.TransportUpdate-error:", error);
                    this.$snotify.error(error.message, "Error!");
                });
        },

        createTransport() {
            this.loading = true;
            this.transport["transportLocation"] = this.googleLocation.name;
            this.transport["geoloc"] = this.coordinates;
            return transportService
                .addTransportPoint(this.transport)
                .then((response) => {

                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.transport.transportName} has been added successfully.`
                    );
                    this.$router.push("/transport");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data.message == "Transport Name already exists") {
                        var errorMessage = "Transfer Point Name is already exists!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else if (error.data.message == "Transport Location already exists") {
                        var errorMessage = "Transfer Point Location is already exists!";
                        this.$snotify.error(errorMessage, "Error!");
                    } else {
                        this.$snotify.error("Transfer Point Create Failed", "Error!");
                    }

                    // console.log('error',error)
                    // if (error.data && error.data.message){
                    //   this.$snotify.error(error.data.message, "Error!");
                    // } else {
                    //   this.$snotify.error("Transfer Point Create Failed", "Error!");
                    // }
                });
        },

        clearChanges() {
            this.transport = _.cloneDeep(this.oldTransport);
            this.formstate._reset();
        },
        updateTransport() {
            this.loading = true;
            this.transport.transportId = this.$route.params._id;

            this.transport["transportLocation"] = this.googleLocation.name;
            this.transport["geoloc"] = this.coordinates;

            return transportService
                .updateTransportPoint(this.transport, this.oldTransport)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldTransport = _.cloneDeep(this.transport);
                    this.$snotify.success(
                        `The ${this.transport.transportName} has been Updated successfully.`
                    );
                    this.$router.push("/transport");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error("Transfer Point Update Failed", "Error!");
                    }
                });
        },
    },
    created() {
        eventBus.$on("geoLocation", (location) => {
            this.googleLocation = location;
            let locationinfo = Object.values(this.googleLocation);
            this.coordinates = locationinfo.splice(0, 2);
        });
        const promises = [];
        this.loading = true;

        // promises.push(this.getTransport());
        if (this.$route.params && this.$route.params._id && this.$route.params._id != '0') {
            promises.push(this.getTransport());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch(() => {
                this.loading = false;
                this.$snotify.error("Create transport failed", "Error!");
            });
    },
    beforeDestroy() {},

    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },

    // computed: {
    //     ...mapState({
    //         user: state => state.auth.user,
    //     })
    // }
};
</script>

<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    background: #0f6940;
    color: white;
}

.inputwrapper {
    position: relative;
}

.maps {
    position: absolute;
    top: 7px;
    right: 10px;
}

.vue-map-container {
    width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// transportPointCreate.vue?7c381226